import { Card, CardActionArea, CardMedia, Grid, Link } from '@material-ui/core'
import React from 'react'
import Data from './Data/Data';




const Projects = () => {
    console.log('daaaata', Data)
    return (
        <Grid container style={{display: 'flex',flexWrap: 'wrap', padding: '2% 2% 2% 0%', margin: '2% 2% 2% 0%', justifyContent: 'center'}}>
        {
            Data.map((res, i)=>(

            <Card boxShadow={3} style={{margin: '1%',}}>
            <Link
                color="inherit"
                component="button"
                variant="body2"
                onClick={() => {
                
                    window.open(res.url, "", "");
                    
                }}
                >
            <CardActionArea style={{width: 300,  height: '30vh'}} key={i}>
                <CardMedia
                style={{width: '100%', height: '18vh', marginBottom:'2%'}}
                title={res.title}
                image={res.image}
                />
           
                <p style={{textAlign: 'center'}}>{res.title}</p>
                <p style={{textAlign: 'center'}}>{res.tags}</p>

            </CardActionArea>
            </Link>
            </Card>

            ))
        }
            {/* <CardActionArea style={{width: 300, margin: '1%', height: '30vh'}}>
                <CardMedia
                style={{width: '100%', height: '18vh'}}
                title="bla bla"
                image={Projectimg}
                />
                <p style={{textAlign: 'center'}}>Project title</p>

            </CardActionArea>
            <CardActionArea style={{width: 300, margin: '1%', height: '30vh'}}>
                <CardMedia
                style={{width: '100%', height: '18vh'}}
                title="bla bla"
                image={Projectimg}
                />
                <p style={{textAlign: 'center'}}>Project title</p>

            </CardActionArea>
            <CardActionArea style={{width: 300, margin: '1%', height: '30vh'}}>
                <CardMedia
                style={{width: '100%', height: '18vh'}}
                title="bla bla"
                image={Projectimg}
                />
                <p style={{textAlign: 'center'}}>Project title</p>

            </CardActionArea> */}
        </Grid>
    )
}

export default Projects
